module.exports = __webpack_public_path__ + "media/images/checkout/default-6fd12184d49ba024e403eca6c8cac7d9.png";